
import { cookieRead, cookieDelete } from "./cookie_control";
// Standard window func

window.apiUrl = "https://prokom-aimcms.azurewebsites.net";
window.dev = false;

if (window.location.href.match(/\?dev/gi)) {
    window.apiUrl = "https://prokom-aimcms-qa.azurewebsites.net";
    window.dev = true;
}


if (cookieRead("RuntimeMode") == "dev") {
    window.apiUrl = "https://prokom-aimcms-qa.azurewebsites.net";
    window.dev = true;
}

window.getPageUrl = function() {

    let urldivert = location.pathname.substr(1).split(/\/(.+)/);
    let template = urldivert[0] || "frontpage";
    let contentid = urldivert[1] || "";

    return { template: template, contentid: contentid, path: urldivert };

} 


window.getUrlAttr = function(attr) {
    return new URL(window.location.href).searchParams.get(attr);
}

window.urlify = (string) => {

    if (string !== null) {
        string = string.replace(/\s|\,|-/gi, "-").replace(/[å]/gi, "aa").replace(/[å]/gi, "ae").replace(/[ø]/gi, "o").replace(/[_]{2,}/gi, "").toLowerCase();
    }
    return string;

}

window.contentID = "";



if (document.referrer.match(/(https:\/\/aim-admin.azurewebsites.net)/gi)) {
    sessionStorage.setItem("fromcms", true);
}